export default __webpack_public_path__ + "static/FeatureFive-3baee29c60a0a2701493c2debe8b1fc5.webp";